export const sexNavigation = {
  methods: {
    isSelected(sex) {
      return this.$route.params.sex === sex;
    },
    getSelectedSex() {
      return this.$route.params.sex;
    },
    changeSex(sex) {
      this.$store.commit("navigation/setCurrentNavItem", null);
      this.$store.commit("overview/reset");
      this.$store.commit("filters/reset");
      this.$router.push({ name: "Recommendations", params: { sex } });
    }
  }
};
